import {Outlet} from 'react-router-dom';

import {CardBox, ClassicMuiNavTabs} from '@shared/components';
import {
  ROUTE__TRANSACTIONS__DEPOSITS,
  ROUTE__TRANSACTIONS__POOL,
  ROUTE__TRANSACTIONS__TRANSACTIONS,
  ROUTE__TRANSACTIONS__WITHDRAWALS,
} from '@shared/constants';
import {Header} from '@widgets/common';

import {COLOR__WHITE} from '@/theme/colors';

const tabs = [
  {route: ROUTE__TRANSACTIONS__TRANSACTIONS, label: 'Transactions'},
  {route: ROUTE__TRANSACTIONS__POOL, label: 'Transactions (pools)'},
  {route: ROUTE__TRANSACTIONS__DEPOSITS, label: 'Deposits'},
  {route: ROUTE__TRANSACTIONS__WITHDRAWALS, label: 'Withdrawals'},
];

export const TransactionsPage = () => {
  return (
    <>
      <Header title="Transactions" isBackButtonShown={false} mb={2} />

      <CardBox bgcolor={COLOR__WHITE}>
        <ClassicMuiNavTabs tabs={tabs} sx={{mb: 3}} />

        <Outlet />
      </CardBox>
    </>
  );
};
